<script>
import ModelShow from "../models/show";

export default {
  extends: ModelShow,
  page: {
    title: "Detail User",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("jala_users.singular"));
      },
    },
    resourceRoute: { default: "users" },
    modelVariable: { default: "user" },
    denyEdit: {
      default() {
        return !this.$auth.hasJalaTradeRole(['admin']);
      },
    },
    denyDelete: { default: true },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("jala_users.plural")),
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t("jala_users.plural")),
          href: "/users",
        },
        {
          text: this.model && this.model.name ? this.model.name : this.$route.params.key,
          href: `/users/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model)
        ? []
        : [
            {
              key: this.lodash.startCase(this.$t("jala_users.name")),
              value: this.model.name || "-",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.email")),
              value: this.model.email || "-",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.phone")),
              value: this.model.phone || "-",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.position")),
              value: this.model.position || "-",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.role")),
              value: (this.model.roles || []).map((r) => this.lodash.upperFirst(this.$t(`users.roles.${r.name || 'admin'}`))).join(', ') || "-",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("users.is_active")),
              item: this.model.is_active,
              value: {
                props: ['item'],
                template: `<status-badge entity="user" type="status" :status="item ? 'active' : 'inactive'"></status-badge>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("models.created_at")),
              value: this.$moment(this.model.created_at).format('DD MMM, YYYY'),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
          ];
    },
  },
  methods: {
    getModelName(value) {
      return (value || this.model).name || this.getModelKey(value);
    },
    delete() {
      return this.$axios.delete(`/users/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get(`/users/${this.$route.params.key}`, {
          params: { with: "roles" },
        })
        .then((response) => {
          const { data: { data } } = response;
          this.model = data;
          return response;
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
